import {
  BookOpenIcon,
  BuildingOfficeIcon,
  Cog6ToothIcon,
  ListBulletIcon,
  ShieldCheckIcon,
  TagIcon,
  WindowIcon,
} from "@heroicons/react/24/outline";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { NavMain, NavigationLink } from "@/components/ui/sidebar/nav-main";

import { useCareApps } from "@/hooks/useCareApps";

function generateAdminLinks(
  t: TFunction,
  pluginNavItems: NavigationLink[],
): NavigationLink[] {
  const baseUrl = "/admin";
  const links: NavigationLink[] = [
    {
      name: t("questionnaire_one"),
      url: `${baseUrl}/questionnaire`,
      icon: <BookOpenIcon className="h-4 w-4" />,
    },
    {
      name: t("valuesets"),
      url: `${baseUrl}/valuesets`,
      icon: <ListBulletIcon className="h-4 w-4" />,
    },
    {
      name: t("patient_identifier_config"),
      url: `${baseUrl}/patient_identifier_config`,
      icon: <Cog6ToothIcon className="h-4 w-4" />,
    },
    {
      name: t("tag_config"),
      url: `${baseUrl}/tag_config`,
      icon: <TagIcon className="h-4 w-4" />,
    },
    {
      name: t("RBAC"),
      url: `${baseUrl}/rbac`,
      icon: <ShieldCheckIcon className="h-4 w-4" />,
      children: [
        {
          name: t("permissions"),
          url: `${baseUrl}/rbac/permissions`,
        },
        {
          name: t("roles"),
          url: `${baseUrl}/rbac/roles`,
        },
      ],
    },
    {
      name: t("organizations"),
      url: `${baseUrl}/organizations`,
      icon: <BuildingOfficeIcon className="h-4 w-4" />,
      children: [
        {
          name: t("governance"),
          url: `${baseUrl}/organizations/govt`,
        },
        {
          name: t("suppliers"),
          url: `${baseUrl}/organizations/product_supplier`,
        },
        {
          name: t("roles"),
          url: `${baseUrl}/organizations/role`,
        },
      ],
    },
    {
      name: t("apps"),
      url: `${baseUrl}/apps`,
      icon: <WindowIcon className="h-4 w-4" />,
    },
    ...pluginNavItems,
  ];

  return links;
}

export function AdminNav() {
  const { t } = useTranslation();

  const careApps = useCareApps();
  const pluginNavItems = careApps.flatMap((c) =>
    !c.isLoading && c.adminNavItems ? c.adminNavItems : [],
  ) as NavigationLink[];

  return <NavMain links={generateAdminLinks(t, pluginNavItems)} />;
}
